import { styled } from '@creditas-ui/system';
import { Flex } from '@creditas-ui/layout';

const Overlay = styled(Flex)`
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
`;

export { Overlay };
